module.exports = "<button class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer></button>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module id = ../../../../../src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module chunks = main